import { useClubsQuery } from '@data/clubs/useClubsQuery';
import { useCompetitionQuery } from '@data/competitions/useCompetitionQuery';
import { ClubListFormData } from './contracts';
import ClubListUI from './ClubListUI';
import { SkeletonLoader } from '@ui/common/components/SkeletonLoader';

export type ClubListProps = ClubListFormData;

export function ClubList({ competitionId, hideCompetitionName = false, columns = 3, nameType }: ClubListProps) {
  const {
    data: clubs,
    isLoading: areClubsLoading,
    error: clubsError,
  } = useClubsQuery({
    variables: {
      competitionId,
      limit: 100,
      page: 1,
    },
  });

  const {
    data: competition,
    isLoading: isCompetitionLoading,
    error: competitionError,
  } = useCompetitionQuery(competitionId);

  if (areClubsLoading || isCompetitionLoading) {
    return (
      <div style={{ display: 'block', width: '100%', height: '100%' }}>
        <SkeletonLoader count={21} />
      </div>
    );
  }

  if (!clubs || !competition || clubsError || competitionError) {
    return null;
  }

  return (
    <ClubListUI
      clubs={clubs.items}
      competition={competition}
      hideCompetitionName={hideCompetitionName}
      columns={columns}
      nameType={nameType}
    />
  );
}
